var _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCreateupLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_6_1",
    "data-name": "Component 6 \\u2013 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 37,
    viewBox: "0 0 50 37",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_14",
    "data-name": "Group 14",
    transform: "translate(0 19)",
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "currentColor",
    id: "Rectangle_98",
    "data-name": "Rectangle 98",
    width: 50,
    height: 1,
    rx: 0.5,
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    id: "Path_20",
    "data-name": "Path 20",
    d: "M.781,0H49.219a.781.781,0,0,1,0,1.563H.781A.781.781,0,0,1,.781,0Z",
    transform: "translate(0 1.313)"
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "currentColor",
    id: "Rectangle_100",
    "data-name": "Rectangle 100",
    width: 50,
    height: 1,
    rx: 0.5,
    transform: "translate(0 3)"
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "currentColor",
    id: "Rectangle_101",
    "data-name": "Rectangle 101",
    width: 46,
    height: 2,
    rx: 1,
    transform: "translate(2 4)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_102",
    "data-name": "Rectangle 102",
    width: 46,
    height: 2,
    rx: 1,
    transform: "translate(2 6)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21",
    "data-name": "Path 21",
    d: "M1.172,0H41.8a1.172,1.172,0,0,1,0,2.344H1.172A1.172,1.172,0,0,1,1.172,0Z",
    transform: "translate(3.906 7.563)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_104",
    "data-name": "Rectangle 104",
    width: 38,
    height: 1,
    rx: 0.5,
    transform: "translate(6 10)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_105",
    "data-name": "Rectangle 105",
    width: 34,
    height: 2,
    rx: 1,
    transform: "translate(8 11)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_106",
    "data-name": "Rectangle 106",
    width: 31,
    height: 2,
    rx: 1,
    transform: "translate(10 13)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_107",
    "data-name": "Rectangle 107",
    width: 25,
    height: 1,
    rx: 0.5,
    transform: "translate(13 15)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_108",
    "data-name": "Rectangle 108",
    width: 17,
    height: 2,
    rx: 1,
    transform: "translate(17 16)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_13",
    "data-name": "Group 13",
    transform: "translate(5)",
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_87",
    "data-name": "Rectangle 87",
    width: 13,
    height: 2,
    rx: 1,
    transform: "translate(14)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_88",
    "data-name": "Rectangle 88",
    width: 20,
    height: 1,
    rx: 0.5,
    transform: "translate(10 2)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_89",
    "data-name": "Rectangle 89",
    width: 24,
    height: 2,
    rx: 1,
    transform: "translate(8 3)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_90",
    "data-name": "Rectangle 90",
    width: 25,
    height: 1,
    rx: 0.5,
    transform: "translate(8 5)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_91",
    "data-name": "Rectangle 91",
    width: 29,
    height: 2,
    rx: 1,
    transform: "translate(6 6)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_92",
    "data-name": "Rectangle 92",
    width: 32,
    height: 2,
    rx: 1,
    transform: "translate(4 8)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_93",
    "data-name": "Rectangle 93",
    width: 35,
    height: 2,
    rx: 1,
    transform: "translate(3 10)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_94",
    "data-name": "Rectangle 94",
    width: 36,
    height: 1,
    rx: 0.5,
    transform: "translate(2 12)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_95",
    "data-name": "Rectangle 95",
    width: 40,
    height: 2,
    rx: 1,
    transform: "translate(0 13)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_96",
    "data-name": "Rectangle 96",
    width: 40,
    height: 1,
    rx: 0.5,
    transform: "translate(0 15)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_97",
    "data-name": "Rectangle 97",
    width: 40,
    height: 2,
    rx: 1,
    transform: "translate(0 16)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreateupLogo);
export default __webpack_public_path__ + "static/media/Createup-logo.ecc216a124b7a56307a61741c4816a6e.svg";
export { ForwardRef as ReactComponent };